import { useState } from "react";

import { ReactSelect } from "../../kits/Inputs/Inputs";
import FormulationPrice from "../formulation-tab/FormulationPrice";
import CustomButton from "../../kits/button/CustomButton";
import ToastCustomize from "../../kits/ToastCustomize";
import { TrashIcon } from "../../kits/Icons";
import ColorSchema from "../../kits/Color";

export default function PriceFormulation({
  productInFormulation,
  selectProduct,
  data,
  attributeProductList,
  formulationListPrice,
  setFormulationListPrice,
  changeHandlerFormulationPrice,
}) {
  const [mathPreviewList, setMathPreviewList] = useState({});
  const [enterFormulList, setEnterFormulList] = useState({});
  const [formulationListMain, setFormulationListMain] = useState({});
  const [resetStates, setResetStates] = useState(false);
  /**
   *
   * @param {*} type mathPreviw OR enterFormul
   * @param {*} value
   * @param {*} labelId
   */
  const formulationHandler = (type, value, labelId) => {
    let temp = "";

    temp = { [labelId.value]: value };

    if (type == "mathPreview") {
      setMathPreviewList((prev) => {
        return { ...prev, ...temp };
      });
    } else if (type == "enterFormul") {
      setEnterFormulList((prev) => {
        return { ...prev, ...temp };
      });
    }
  };
  const addFormulation = (e, id) => {
    setFormulationListMain((prev) => ({ ...prev, [id]: e }));
  };
  const resetState = () => {
    setMathPreviewList({});
    setEnterFormulList({});
    setFormulationListMain({});
    setResetStates(true);
  };
  const saveProperty = () => {
    let validate = true;
    data?.property?.map((value) => {
      let temp = formulationListMain[value.value];

      if ((temp != undefined && temp.length == 0) || temp == undefined) {
        validate = false;
      }
    });
    if (validate) {
    } else {
      ToastCustomize({
        mainText: "فرمول تمام صفات را پر کنید.",
        duration: 3000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
  };
  return (
    <div className="">
      <div className="col-lg-4 col-md-6 col-12 mx-auto">
        <ReactSelect
          title="انتخاب ماده اولیه"
          itemsList={productInFormulation}
          inputValue={data?.product}
          onChangeFunc={(e) => {
            selectProduct(e);
            resetState();
          }}
        />
      </div>

      <div>
        <div className="d-flex flex-wrap">
          {data?.property?.map((value, index) => (
            <div className="col-md-6 col-12" key={index}>
              <FormulationPrice
                math
                title={value?.label}
                attributeProductList={attributeProductList}
                chooseMainProperty={false}
                attributeBaseOnProduct={[]}
                hasLimit={true}
                limitCount={"1"}
                mathPreview={mathPreviewList[value.value] ?? ""}
                setMathPreview={(e) => {
                  formulationHandler("mathPreview", e, value, value.value);
                }}
                enterFormul={enterFormulList[value.value] ?? []}
                setEnterFormul={(e) => {
                  formulationHandler("enterFormul", e, value, value.value);
                }}
                addFormulation={(e) => addFormulation(e, value.value)}
                reset={resetStates}
              />
            </div>
          ))}
        </div>
      </div>
      {data?.property?.length > 0 && (
        <div className="d-flex justify-content-end mt-3 align-items-center ms-auto me-3">
          <CustomButton
            className=""
            onClick={() => {
              saveProperty();
            }}
            color="success"
          >
            ذخیره
          </CustomButton>
        </div>
      )}

      <div className="mx-auto col-12 rounded border mt-4 ">
        <h4 className="fw-bold bg-secondary d-inline-block text-light py-2 px-3 rounded">
          لیست فرموله سازی قیمت
        </h4>
        <div className="p-3">
          <div className="my-3 d-flex align-items-center">
            <div className="d-flex">
              <h6 className="fw-bold" style={{ fontSize: 14 }}>
                1- نام ماده اولیه:
              </h6>
              <span className="ms-1" style={{ fontSize: 14 }}>
                پارچه
              </span>
            </div>
            <Divider />
            <ShowProperty prName={"عرض طاقه"} prValue={9} />
            <Divider />
            <ShowProperty prName={"طول طاقه"} prValue={977} />
            <div></div>
            <TrashIcon
              containerIconClassName="ms-4 cursor-pointer"
              color={ColorSchema.danger_custom}
              width={20}
              height={20}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
const ShowProperty = ({ prName, prValue }) => {
  return (
    <div className="d-flex">
      <h6 className="fw-bold" style={{ fontSize: 14 }}>
        صفت:
      </h6>
      <span className="ms-1" style={{ fontSize: 14 }}>
        {prName}
      </span>
      &nbsp;
      {` => `}&nbsp;
      <h6 className="fw-bold" style={{ fontSize: 14 }}>
        فرمول:
      </h6>
      <span className="ms-1" style={{ fontSize: 14 }}>
        {prValue}
      </span>
    </div>
  );
};

const Divider = () => {
  return (
    <div
      className="mx-2"
      style={{ border: "1px solid darkgray", height: 15, width: 1 }}
    />
  );
};
